import { useState } from 'react'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from '@/common/ui/dialog'
import { Button } from '@/common/ui/button'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import { useQueryClient } from '@tanstack/react-query'
import { ProfilePageBannerQueryKeys } from '@/modules/client-setting/keys'
import { ProfilePageBannerData } from '@/modules/client-setting/type'
import useMutationUpdateProfilePageBanner from '@/modules/client-setting/api/hooks/useMutationUpdateProfilePageBanner'
import { PencilIcon } from 'lucide-react'
import ProfilePageBannerForm, {
	ProfilePageBannerFormValues,
} from '../../../../../ProfilePageBannerForm'
import { ProfilePageBannerType } from '@/schema'

interface UpdateProfilePageBannerProps {
	data: ProfilePageBannerData
}

export default function UpdateProfilePageBanner({
	data,
}: UpdateProfilePageBannerProps) {
	const [open, setOpen] = useState(false)
	const { mutate: updateProfilePageBanner } =
		useMutationUpdateProfilePageBanner()
	const queryClient = useQueryClient()

	const defaultValues: Partial<ProfilePageBannerFormValues> = {
		title: data.title,
		image: data.image,
		type: data.type as ProfilePageBannerType,
		link: data.link || '',
		gameCode: data.gameCode || '',
		order: data.order,
		isActive: data.isActive,
	}

	const onSubmit = (formData: ProfilePageBannerFormValues) => {
		const payload = {
			title: formData.title,
			image: formData.image,
			type: formData.type,
			link: formData.type === 'LINK' ? formData.link : undefined,
			gameCode: formData.type === 'GAME' ? formData.gameCode : undefined,
			order: formData.order,
			isActive: formData.isActive,
		}

		updateProfilePageBanner(
			{ id: data.id, payload },
			{
				onSuccess: () => {
					toast.success('แก้ไขปุ่มทางเข้าเกมสำเร็จ')
					setOpen(false)
					queryClient.invalidateQueries({
						queryKey: [ProfilePageBannerQueryKeys.GetProfilePageBanners],
					})
				},
				onError: (error) => {
					showErrorToast(error)
				},
			},
		)
	}

	return (
		<Dialog open={open} onOpenChange={setOpen}>
			<DialogTrigger asChild>
				<Button variant="ghost" size="icon">
					<PencilIcon className="size-4" />
				</Button>
			</DialogTrigger>
			<DialogContent className="sm:max-w-[600px]">
				<DialogHeader>
					<DialogTitle>แก้ไขปุ่มทางเข้าเกม</DialogTitle>
				</DialogHeader>
				<ProfilePageBannerForm
					defaultValues={defaultValues}
					onSubmit={onSubmit}
					submitButtonText="แก้ไขปุ่ม"
					showOrder={true}
				/>
			</DialogContent>
		</Dialog>
	)
}
